import { produce } from 'unitx/immer';
/* eslint-disable functional/immutable-data, functional/no-expression-statement */

export const produceWithAsync = async (state, updater) => {
  const nextStatePromise = await produce(state, updater);
  const nextState = await nextStatePromise;
  return nextState;
};
export const produceWithPatchesAsync = async (state, updater) => {
  let patches = null;
  let inversePatches = null;
  const nextState = await produce(state, updater, (p, ip) => {
    patches = p;
    inversePatches = ip;
  });
  return [await nextState, patches, inversePatches];
};
/* eslint-enable functional/immutable-data, functional/no-expression-statement */